<template>
  <div class="zsca-huodong">
    <HomeHeader :entryList="entryList" />
    <div class="main">
      <div class="zsca-content">
        <div
          class="title-box"
          :style="{
            'background-color': isScrollTop ? 'var(--zs-kc-tab-scrolltop-bg-color)' : 'var(--zs-kc-tab-scroll-bg-color)'
          }"
        >
<!--          <img class="back-btn" src="@/assets/zs_imgs/wiki-icon-back.png" alt="返回" @click="handleRouterBack" />-->
          <div class="title-pic"></div>
          <!-- <span class="title-txt">活动</span> -->
        </div>
        <div class="active-bar-box">
          <ActiveBar
            ref="activeBar"
            :keyword="fetchParams.keyword"
            @input="onSearchInput"
            @sort="onConditionSortChange"
          />
        </div>
        <div class="card-box">
          <template v-if="cardList.length">
            <!-- <router-link v-for="item in cardList" :key="item.id" :to="`/${alias}/card-pool/${serverId}?ancher=${item.id}`">
          <CardItem :item="item" :searchKey="fetchParams.keyword" />
        </router-link> -->
            <CardItem
              v-for="item in cardList"
              :key="item.id"
              :item="item"
              :searchKey="fetchParams.keyword"
              :kindName="kindName"
            />
          </template>
          <template v-else>
            <EmptyResult @more="onEmptyResultMore" />
          </template>
        </div>
        <CommentLikeComponent :type="type"></CommentLikeComponent>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from "@/plugins/util";
import { apiContentTopList } from "@/api/contentApi";
import { apiGetActivityList } from "@/api/wiki-zsca";
import { apiWikiEntry } from "@/api/wikiApi";

import HomeHeader from "../components/homeHeader";
import ActiveBar from "./components/ActiveBar.vue";
import CardItem from "./components/CardItem.vue";
import EmptyResult from "./components/EmptyResult.vue";
import CommentLikeComponent from "../components/commentLikeComponent.vue";

export default {
  name: "ZscaKachi",
  components: {
    ActiveBar,
    CardItem,
    EmptyResult,
    HomeHeader,
    CommentLikeComponent
  },
  data() {
    return {
      type: 8, // 卡池类型
      kindName: "",
      serverId: 0,
      cardList: [],
      entryList: [],
      isScrollTop: true,
      fetchParams: {
        /** 0 全部，1 重要，-1 不重要 */
        importance: 0,
        /** -1 从新到旧，1 从旧到新 */
        sort: -1,
        /** 搜索关键字 */
        keyword: "",
        limit: 999,
        page_no: 1,
        /** 服区id */
        serverId: this.$route.params.id,
        /** 0 全部，1 进行中，2 已结束 */
        status: 0
      }
    };
  },
  beforeMount() {
    this.serverId = this.$route.params.id;
  },
  async mounted() {
    await this.fetchCardList();

    window.addEventListener("scroll", this.onWindowScrollTop);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onWindowScrollTop);
  },
  methods: {
    async initData() {
      let pagination = {
        limit: 13,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      const params2 = {
        ...pagination,
        type: "4,17",
        order_by: "created_at",
        keyword: ""
      };
      const resList = await Promise.all([apiContentTopList(params2), apiWikiEntry()]);

      if (resList[0].code == 0 && resList[0].data) {
        this.topList = resList[0].data.reduce((prev, curr) => {
          if (prev.length > 3) return prev;
          if (curr.is_top) {
            prev.push(curr);
          }
          return prev;
        }, []);
      }

      if (resList[0].code == 0) {
        this.list = resList[0].data.slice(this.topList.length);
        pagination = resList[0].meta.pagination;
      }

      this.entryList = resList[1].data.entry_list;
    },
    async fetchCardList() {
      const { code, data } = await apiGetActivityList(this.fetchParams);
      if (code === 0) {
        this.cardList = data;
      }
    },

    onSearchInput: debounce(function(value) {
      this.cardList = [];
      this.fetchParams.keyword = value;
      this.fetchCardList();
    }, 1000),
    onConditionSortChange(command) {
      this.cardList = [];
      this.fetchParams.sort = Number(command);
      this.fetchCardList();
    },

    onEmptyResultMore() {
      this.fetchParams = {
        /** 0 全部，1 重要，-1 不重要 */
        importance: 0,
        /** -1 从新到旧，1 从旧到新 */
        sort: -1,
        /** 搜索关键字 */
        keyword: "",
        limit: 999,
        page_no: 1,
        /** 服区id */
        serverId: this.$route.params.id,
        /** 0 全部，1 进行中，2 已结束 */
        status: 0
      };
      this.cardList = [];
      this.fetchCardList();
    },
    onWindowScrollTop(event) {
      this.isScrollTop = event.target.scrollingElement.scrollTop < 20;
    },
    handleRouterBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.zsca-huodong {
  padding-top: 70px;
  min-height: 100vh;
  background-repeat: no-repeat;
  // background: fixed;
  // background-image: var(--zs-qz-bg-img);
  // background-size: 100% 100%;
  .main {
    display: flex;
    flex-direction: column;
    width: 888px;
    margin: 0 auto;
    min-height: calc(100vh - 70px);
    padding: 13px 10px;
    border-radius: 12px;
    background-color: var(--zs-wiki-home-main-bg);

    .zsca-content {
      flex-grow: 1;
      border-radius: 8px;
      background-color: var(--zs-wiki-banner-bg);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .title-box {
        position: relative;
        padding: 10px 36px;
        border-bottom: 1px solid var(--zs-kc-tab-bottom-border-color);
        position: sticky;
        top: 60px;
        z-index: 9;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        display: flex;
        align-items: center;
        .back-btn {
          position: absolute;
          top: 50%;
          left: -60px;
          z-index: 1;
          width: 40px;
          height: 40px;
          padding: 10px;
          background: var(--zs-aside-bar-bg);
          border-radius: 30px;
          transform: translateY(-50%);
        }
        .title-pic {
          height: 28px;
          width: 100%;
          background-size: contain;
          background-position: left center;
          background-repeat: no-repeat;
          background-image: var(--zs-kc-hd-title-logo);
        }
        .title-txt {
          color: var(--zs-kc-hd-title-color);
          font-size: 17px;
          font-weight: 500;
          margin-left: 4px;
        }
      }
      .active-bar-box {
        padding: 20px 36px;
      }
      .card-box {
        padding: 0 36px 10px 36px;
      }
    }
  }
}
</style>
